// Each JSON in this directory is a *partial* override of the matching upstream
// `app/javascript/dashboard/i18n/locale/pt_BR/<name>.json`. The top-level
// dashboard i18n loader deep-merges this object onto the upstream pt_BR
// bundle, so any key not listed here keeps its upstream translation.

import conversation from './conversation.json';
import helpCenter from './helpCenter.json';
import inboxMgmt from './inboxMgmt.json';
import integrations from './integrations.json';
import internalChat from './internalChat.json';
import settings from './settings.json';
import signup from './signup.json';

export default {
  ...conversation,
  ...helpCenter,
  ...inboxMgmt,
  ...integrations,
  ...internalChat,
  ...settings,
  ...signup,
};
